import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';

import { Context } from '../../context/DataContext';

const CheckPDFPage = () => {
  const navigate = useNavigate();
  const { state } = React.useContext(Context);
  const {
    customerInfo: {
      orderId,
      serviceName,
      payType,
      insuranceNo,
      fromDate,
      toDate,
      name,
      id,
      birthday,
      address,
      market_n,
      imei,
      phonePrice,
      phone,
      repairTarget,
      repairCount,
      swapPrice,
      insurancePrice,
      periodType,
    },
    loginInfo: {
      empName,
      empCode,
      // dealerNo
    },
  } = state;
  const queryString = new URLSearchParams({
    order_id: orderId,
    service_name: serviceName,
    payment_type: payType,
    info_jstr: JSON.stringify({
      insurance_number: insuranceNo,
      period: `${fromDate} - ${toDate}`,
      name,
      id,
      birthday,
      address,
      model_name: market_n,
      imei,
      phone_price: phonePrice,
      phone,
      target: repairTarget,
      repair_count: repairCount,
      swap: swapPrice,
      price: insurancePrice,
      installment_price: payType === 'installment' ? insurancePrice : '',
      licenseNo: empCode,
      insuranceAgentName: empName,
      extraTerms:
        periodType === 'B' ? '安達產物行動裝置保險電池維修置換附加條款(D)' : '',
    }),
  }).toString();

  return (
    <Box sx={{ pb: 8 }}>
      <Typography variant='h4' sx={{ my: 2 }}>
        要保書確認
      </Typography>
      <Box>
        <embed
          style={{
            height: 'calc(100vh - 234px)',
            width: '100%',
          }}
          src={`${process.env.REACT_APP_LEAGUE_BASE_WEB_URL}/m/insurance/consent/finalview?${queryString}`}
        />
        <Button
          variant='contained'
          sx={{ width: 168 }}
          onClick={() => {
            navigate('/burglary-insur/upload-photos');
            // how to pay with api
            // payment success --> upload photos
            // switch (payType) {
            //   case 'installment':
            //   case 'credit':
            //     navigate('/tap-pay');
            //     break;
            //   case 'cash':
            //     if (dealerNo === '017' || dealerNo === '008') {
            //       navigate('/barcode');
            //     } else {
            //       navigate('/upload-photos');
            //     }
            //     break;
            //   case 'tel_bill':
            //     // Call check api then go to upload photos page
            //     navigate('/upload-photos');
            //     break;

            //   default:
            //     navigate('/upload-photos');
            //     break;
            // }
          }}
        >
          下一步
        </Button>
        {/* Test for burglary insurance phase 2 */}
        {/* {process.env.REACT_APP_ENV === 'production' ||
        process.env.REACT_APP_ENV === 'leaguetech-production' ? null : (
          <Button
            color='info'
            variant='contained'
            sx={{ width: 168 }}
            onClick={() => {
              navigate('/burglary-insur/order-completed');
            }}
          >
            測試用下一步到完成頁
          </Button>
        )} */}
      </Box>
    </Box>
  );
};

export default CheckPDFPage;
